import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Divider,
  Typography,
} from '@material-ui/core'
import dashboardTeaser from './dashboard-teaser.png'
import systemPermissions from 'common/system-permissions'

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 20,
    fontWeight: 500,
  },
  teaserImage: {
    width: 232,
  },
  actions: {
    justifyContent: 'space-between',
  },
}))

const RequestPermissionModal = ({ role, show, onHide }) => {
  const styles = useStyles()
  const getDescription = () => {
    switch (role) {
      case systemPermissions.MANAGE_COLLEGE_CONTENT:
        return ' to create content.'
      case systemPermissions.MANAGE_COLLEGE_OUTREACH_MESSAGES:
        return ' to message students and parents.'
      case systemPermissions.PERFORM_VISIT_MANGEMENT_TASKS:
        return ' to schedule visits.'
      default:
        return '.'
    }
  }
  const getName = () => {
    switch (role) {
      case systemPermissions.MANAGE_COLLEGE_CONTENT:
        return 'Content Manager role'
      case systemPermissions.MANAGE_COLLEGE_OUTREACH_MESSAGES:
        return 'Student Outreach role'
      case systemPermissions.PERFORM_VISIT_MANGEMENT_TASKS:
        return 'Admissions Representative role'
      default:
        return 'role'
    }
  }

  return (
    <Dialog
      open={show}
      onClose={onHide}
    >
      <DialogTitle>
        <Typography className={styles.title}>Additional permissions required</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box
          display={'flex'}
          width={'100%'}
          height={233}
          borderRadius={6}
          alignItems={'center'}
          justifyContent={'center'}
          bgcolor={'#BBE4EF'}
        >
          <img
            className={styles.teaserImage}
            src={dashboardTeaser}
            alt="preview of dashboard analytics"
          />
        </Box>
      </DialogContent>
      <DialogTitle>{`Uh oh! You don't have the right permissions${getDescription()}`}</DialogTitle>
      <DialogContent>
        <DialogContentText>{`Ask your account admin to give you the ${getName()}.`}</DialogContentText>
        <DialogActions className={styles.actions}>
          <Button
            variant="text"
            onClick={onHide}
            color={'primary'}
          >
            Cancel
          </Button>
          <Button
            href="https://scoir.helpdocs.io/article/6metpdhlpi-admissions-officer-roles-and-permissions"
            target="_blank"
            variant="contained"
            color="primary"
          >
            Learn More
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

RequestPermissionModal.propTypes = {
  role: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}

export default RequestPermissionModal
